import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import RPMPlus from "../components/Products/RPMPlus";
import Catalog from "../components/Products/Catalog";
import Purchases from "../components/Products/Purchases";

const ProductsMain = (props) => {
  const loadedContent = props.content;
  const navigate = useNavigate();

  useEffect(() => {
    if (loadedContent.redirect) {
      navigate(loadedContent.direction);
    }
  }, [loadedContent, navigate]);

  return (
    <>
      {loadedContent.rpmplus && loadedContent.rpmplus.products.length > 0 && <RPMPlus content={loadedContent.rpmplus} />}
      {loadedContent.products && (
        <Catalog
          products={loadedContent.products}
          categories={loadedContent.categories}
          rpmpass={loadedContent.rpmpass}
          currency={loadedContent.currency}
        />
      )}
      {loadedContent.purchases && (
        <Purchases purchases={loadedContent.purchases} />
      )}
    </>
  );
};

export default ProductsMain;
